<template>
    <div class="col-lg-6 col-md-12">
        <div class="widget-11-row row">
            <div class="col-md-6">
                <div class="half-box dark">
                    <img src="/assets/img/svg/flash-card.svg" alt="">
                    <span class="title" v-html="widget.attributes.column1label.attributeValue"></span>
                </div>
                <div class="half-box light">
                    <!-- <img src="assets/img/svg/bell.svg" alt=""> -->
                    <!-- <img class="grey" src="assets/img/svg/lightning-no.svg" alt="">
                    <img class="yellow" src="assets/img/svg/alert-triangle.svg" alt=""> -->
                    <img v-if="!alarm['LAST_0'] && !alarm['LAST_1'] " class="green" src="/assets/img/png/check-mark.png" alt="">
                    <img v-else class="red" src="assets/img/svg/alert-octagon.svg" alt="">
                    <span class="title" v-html="widget.attributes.column2label.attributeValue"></span>
                </div>
            </div>
            <div class="col-md-3">
                <div :class="!alarm['LAST_0'] ? 'box power bleach': 'box power bleach active-statbox'">
                    <span class="label" v-html="widget.attributes.column3ParamDescription != undefined ? widget.attributes.column3ParamDescription.attributeValue: ''"></span>
                    <span v-if="data['LAST_0'] != undefined && data['LAST_0'][0] != undefined && data['LAST_0'][0].stringValue != undefined && ready" class="value">{{ data['LAST_0'][0].stringValue != undefined ? data['LAST_0'][0].stringValue: '' }}
                        <span v-if="data['LAST_0'][0].stringUnit != undefined" class="unit">{{  ' ' + data['LAST_0'][0].stringUnit }}</span>

                    </span>
                    <span v-else-if="ready" class="value value-small">{{ "notAvailable" | translate }}</span>
                    <span v-else class="value"></span>
                    <template v-if="data['LAST_0'] != undefined && data['LAST_0'][0] != undefined && data['LAST_0'][0].stringTimestamp != undefined">
                        <div class="last-acquisition" v-html="data['LAST_0'][0].stringTimestamp"></div>
                    </template>
                </div>
            </div>
            <div class="col-md-3">
                <div :class="!alarm['LAST_1'] ? 'box power white': 'box power white active-statbox'">
                    <span class="label" v-html="widget.attributes.column4ParamDescription != undefined ? widget.attributes.column4ParamDescription.attributeValue: ''"></span>
                    <span v-if="data['LAST_1'] != undefined && data['LAST_1'][0] != undefined && data['LAST_1'][0].stringValue != undefined && ready" class="value" v-html="(data['LAST_1'][0].stringValue != undefined ? data['LAST_1'][0].stringValue: '') + ' ' + (data['LAST_1'][0].stringUnit != undefined ? data['LAST_1'][0].stringUnit: '')"></span>
                    <span v-else-if="ready" class="value value-small">{{ "notAvailable" | translate }}</span>
                    <span v-else class="value"></span>
                    <template v-if="data['LAST_1'] != undefined && data['LAST_1'][0] != undefined && data['LAST_1'][0].stringTimestamp != undefined">
                        <div class="last-acquisition" v-html="data['LAST_1'][0].stringTimestamp"></div>
                    </template>
                </div>
            </div>
        </div>
        
        <overlay :enabled="loading"></overlay>
    </div>    
</template>

<script>
    import moment from 'moment'
    import notificator from '@/mixins/notificator';

    import Overlay from '@/components/Overlay.vue';

    export default {
        props: ['widget'],

        components: {Overlay},

        mixins: [notificator],

        data() {
            return {
                ready: false,
                loading: false,
                timer: null,
                data: {},

                alarm: {
                    'LAST_0': false,
                    'LAST_1': false,
                }
            }
        },

        created() {    
            this.start();
        },
        
        methods: {
            start() {
                this.getTSData()

                this.timer = setInterval(() => {
                    this.getTSData()
                }, 60000);
            },

            generateDevicesQueries() {
                var offset = new Date().getTimezoneOffset();

                var devicesQueries = [
                    {
                        'aggregation': {
                            'mode': 'LAST'
                        },
                        'aqDatetimeLowerbound': moment().subtract(1, 'days').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z',
                        'aqDatetimeUpperbound': moment().add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z',
                        'deviceIds': [this.widget.deviceId], 
                        'paramIds': [parseInt(this.widget.attributes.column3paramId1.attributeValue)],
                        'queryId': 'LAST_0',
                        'readingType': 'HOT'/* this.widget.attributes.readingType.attributeValue */
                    }
                ];

                if(this.widget.attributes.column4paramId2 != undefined)
                    devicesQueries.push(
                        {
                            'aggregation': {
                                'mode': 'LAST'
                            },
                            'aqDatetimeLowerbound': moment().subtract(1, 'days').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z',
                            'aqDatetimeUpperbound': moment().add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z',
                            'deviceIds': [this.widget.deviceId], 
                            'paramIds': [parseInt(this.widget.attributes.column4paramId2.attributeValue)],
                            'queryId': 'LAST_1',
                            'readingType': 'HOT'/* this.widget.attributes.readingType.attributeValue */
                        }
                    );

                return devicesQueries;                
            },

            getTSData() {

                if(!this.ready)
                    this.overlay(true);

                this.$store
                .dispatch('getTSData', {devicesQueries: this.generateDevicesQueries()})
                .catch(error => {
                    if(!this.ready)
                    this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: error}));            

                    this.data = {};

                    if(!this.ready)
                        this.ready = true;
                })
                .then(({data}) => {
                    if(!this.ready)
                    this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: 200}));

                    if(data != undefined && data.deviceQueriesResponse != undefined && data.deviceQueriesResponse.LAST_0 != undefined) {
                        // if(data.deviceQueriesResponse.LAST_0[0].stringTimestamp != undefined)
                        //     data.deviceQueriesResponse.LAST_0[0].stringTimestamp = data.deviceQueriesResponse.LAST_0[0].stringTimestamp.split(" ")
                        
                        // if(data.deviceQueriesResponse.LAST_1[0].stringTimestamp != undefined)
                        //     data.deviceQueriesResponse.LAST_1[0].stringTimestamp = data.deviceQueriesResponse.LAST_1[0].stringTimestamp.split(" ")

                        this.data = data.deviceQueriesResponse;

                        if(data.deviceQueriesResponse.LAST_0[0] != undefined && data.deviceQueriesResponse.LAST_0[0].isOld != undefined && data.deviceQueriesResponse.LAST_0[0].isOld)
                            this.alarm['LAST_0'] = true;
                        else 
                            this.alarm['LAST_0'] = false;
                        
                        if(data.deviceQueriesResponse.LAST_1 != undefined && data.deviceQueriesResponse.LAST_1[0] != undefined && data.deviceQueriesResponse.LAST_1[0].isOld != undefined && data.deviceQueriesResponse.LAST_1[0].isOld)
                            this.alarm['LAST_1'] = true;
                        else 
                            this.alarm['LAST_1'] = false;
                    } else {
                        this.data = {};
                        this.alarm = {
                            'LAST_0': true,
                            'LAST_1': true,
                        }
                    }

                    if(!this.ready)
                        this.ready = true;
                });          
            },

            overlay(action) {
                this.loading = action;
            }
        },

        beforeDestroy: function(){
            clearInterval(this.timer);
        }
    }
</script>

